module.exports = __webpack_public_path__ + "img/card1.bec78588.gif";